import {
  BOOKING_STATUS,
  DEAL_STATUS,
  DEAL_STATUS_NAME,
  PROJECT_STATUS,
  PROJECT_STATUS_NAME,
  PROJECT_TYPE,
  Roles,
  USER_STATUS,
} from "@/constant/constants";
import moment from "moment";

const headerStyle = {
  whiteSpace: "nowrap",
};

export const monthFilterOptions = Array(5)
  .fill(null)
  .map((_, i) => ({
    label: moment().subtract(i, "years").format("YYYY"),
    value: moment().subtract(i, "years").format("YYYY"),
  }));

export const dashboardTableHeaders = [
  { label: "Product ID", value: "id" },
  { label: "Product Name", value: "name" },
  { label: "Category", value: "category" },
  { label: "Price", value: "price" },
  { label: "Status", value: "status" },
  {
    label: "Action",
    value: "action",
    dataStyle: { textAlign: "center" },
    headerStyle: { textAlign: "center" },
  },
];

export const bookings_table_header = [
  { label: "Booking ID", value: "bookingId" },
  { label: "Customer Name", value: "customerName" },
  { label: "Operator Name", value: "operatorName" },
  { label: "Parking", value: "parking" },
  { label: "Date", value: "date" },
  { label: "Total Price", value: "totalPrice" },
  { label: "Status", value: "status" },
  { label: "Actions", value: "actions" },
];
export const airport_headers = [
  {
    label: "Airport Code",
    value: "airportCode",
  },
  {
    label: "Airport Name",
    value: "airport",
  },
  {
    label: "Address",
    value: "address",
  },
  {
    label: "Total Terminals",
    value: "totalTerminals",
  },
  {
    label: "Created At",
    value: "createdAt",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Action",
    value: "action",
  },
];
export const terminal_headers = [
  {
    label: "Terminal ID",
    value: "terminalId",
  },
  {
    label: "Airport Name",
    value: "airport",
  },
  {
    label: "Terminal Name",
    value: "terminalName",
  },
  {
    label: "Capacity",
    value: "capacity",
  },
  {
    label: "Active Slots",
    value: "activeSlots",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Action",
    value: "action",
  },
];
export const discount_table_header = [
  { label: "Discount Code", value: "code", headerStyle },
  { label: "Discount Name", value: "name", headerStyle },
  { label: "Type", value: "type", headerStyle },
  { label: "Discount", value: "discount", headerStyle },
  { label: "Valid From", value: "startDate", headerStyle },
  { label: "Valid Until", value: "endDate", headerStyle },
  { label: "Cap Amount", value: "cap", headerStyle },
  {
    label: "Applicable For",
    value: "applyFor",
    headerStyle,
  },
  { label: "Status", value: "status", headerStyle },
  { label: "Action", value: "action", headerStyle },
];
export const applicableForOptions = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "selected",
    label: "Specific Airports",
  },
];
export const applicableForOptionsDiscount = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "selected",
    label: "Specific Airports",
  },
];
export const feesTypeOptions = [
  {
    value: "flat",
    label: "Flat",
  },
  {
    value: "percentage",
    label: "Percentage",
  },
];
export const discountTypeOptions = [
  {
    value: "flat",
    label: "Flat",
  },
  {
    value: "percentage",
    label: "Percentage",
  },
];

export const reviewsHeader = [
  { label: "Customer Name", value: "customerName" },
  { label: "Operator Name", value: "operatorName" },
  { label: "Parking", value: "parking" },
  { label: "Rating", value: "rating" },
  { label: "Booking Date", value: "bookingDate" },
  { label: "Actions", value: "actions" },
];

export const bookingFilter = [
  { label: "All", value: "all" },
  { label: "Pending", value: BOOKING_STATUS.PENDING },
  { label: "Confirmed", value: BOOKING_STATUS.CONFIRMED },
  { label: "In Progress", value: BOOKING_STATUS.IN_PROGRESS },
  { label: "Completed", value: BOOKING_STATUS.COMPLETED },
  { label: "Cancelled", value: BOOKING_STATUS.CANCELLED },
];

export const contact_us_table_header = [
  {
    label: "ID",
    value: "id",
  },
  {
    label: "Name",
    value: "name",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Contact No",
    value: "phone",
  },
  {
    label: "Date",
    value: "date",
  },
  {
    label: "Status",
    value: "status",
  },
  {
    label: "Action",
    value: "action",
  },
];

export const disbursementHeader = [
  { label: "Disbursement", value: "disbursementId" },
  { label: "Operator Name", value: "operatorName" },
  { label: "Disbursed Amount", value: "disbursedAmount" },
  { label: "Payment Method", value: "paymentMethod" },
  { label: "Disbursement Date", value: "createdAt" },
];
export const disbursementUserHeader = [
  { label: "Operator Name", value: "operatorName" },
  { label: "Overall Amount", value: "overallAmount" },
  { label: "Total Amount", value: "totalAmount" },
  { label: "Disbursement Amount", value: "disbursementAmount" },
  { label: "Actions", value: "action" },
];
export const minutesOptions = (function () {
  const options = [];

  for (let i = 15; i <= 60; i += 15) {
    options.push({
      label: `${i} mins`,
      value: i,
    });
  }

  for (let i = 75; i <= 105; i += 15) {
    const hours = Math.floor(i / 60);
    const minutes = i % 60;
    options.push({
      label: `${hours} hr${hours > 1 ? "s" : ""} ${
        minutes > 0 ? `${minutes} mins` : ""
      }`.trim(),
      value: i,
    });
  }

  for (let hour = 2; hour <= 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const totalMinutes = hour * 60 + minute;

      if (totalMinutes > 1440) break;

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      options.push({
        label: `${hours} hr${hours > 1 ? "s" : ""} ${
          minutes > 0 ? `${minutes} mins` : ""
        }`.trim(),
        value: totalMinutes,
      });
    }
  }

  return options;
})();

export const userManagement_table_header = [
  { label: "User ID", value: "userId" },
  { label: "Full Name", value: "fullName" },
  { label: "Company Name", value: "companyName" },
  { label: "Active Projects", value: "activeProjects" },
  { label: "Deals Secured", value: "dealsSecured" },
  { label: "Total Investment", value: "totalInvestment" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];

export const investorTableHeaders = [
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Phone No", value: "phoneNo" },
  { label: "Country", value: "country" },
  { label: "Total Deals", value: "totalDeals" },
  { label: "Projects Funded", value: "projectsFunded" },
  { label: "Email Verified", value: "emailVerified" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];
export const entrepreneurTableHeaders = [
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
  { label: "Company Name", value: "companyName" },

  { label: "Phone No", value: "phoneNo" },
  { label: "Total Projects", value: "totalProjects" },
  { label: "Ongoing Deals", value: "ongoingDeals" },
  { label: "Email Verified", value: "emailVerified" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];

export const projectManagement_filter_type_data = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Scale",
    value: PROJECT_TYPE.WADISCALE,
  },
  {
    label: "Seed",
    value: PROJECT_TYPE.WADISEED,
  },
  {
    label: "Vault",
    value: PROJECT_TYPE.WADIVAULT,
  },
];

export const userManagement_tabs = [
  {
    label: "Enterpreneurs",
    value: Roles.ENTREPRENEUR,
  },
  {
    label: "Investors",
    value: Roles.INVESTOR,
  },
];

export const userManagement_filter_data = [
  {
    label: "All",
    value: "all",
  },
  {
    label: "Active",
    value: USER_STATUS.ACTIVE,
  },
  {
    label: "Suspended",
    value: USER_STATUS.SUSPENDED,
  },
];

export const dealManagement_filter_data = [
  {
    label: "All",
    value: "all",
  },
  ...Object.values(DEAL_STATUS).map((status) => ({
    label: DEAL_STATUS_NAME[status],
    value: status,
  })),
];

export const filterData = [
  {
    label: "Option 1",
    value: "option1",
  },
  {
    label: "Option 2",
    value: "option2",
  },
];

export const userManagement_investors_header = [
  { label: "User ID", value: "userId" },
  { label: "Full Name", value: "fullName" },
  { label: "Total Deals", value: "totalDeals" },
  { label: "Projects Funded", value: "projectsFunded" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];

export const dealManagement_table_header = [
  { label: "Project Name", value: "projectName" },
  { label: "Project Type", value: "projectType" },
  { label: "Entrepreneur", value: "entrepreneur" },
  { label: "Investor", value: "investor" },
  // { label: "Total Value", value: "totalValue" },
  { label: "Date Created", value: "createdAt" },
  { label: "Deal Status", value: "status" },
  { label: "Action", value: "action" },
];

export const dashboard_table_headers = [
  { label: "Project Name", value: "projectName" },
  { label: "Project Category", value: "projectCategory" },
  { label: "Date Uploaded", value: "dateUploaded" },
  { label: "Funding", value: "funding" },
  { label: "Stage", value: "stage" },
  { label: "Industry", value: "industry" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];

export const projectManagement_table_headers = [
  { label: "Entrepreneur Name", value: "entrepreneurName" },
  { label: "Project Name", value: "name" },
  { label: "Project Category", value: "type" },
  { label: "Date Uploaded", value: "dateUploaded" },
  { label: "Industry", value: "industrySector" },
  { label: "Use of Funds", value: "capitalUse" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];

export const reports_table_headers = [
  { label: "Project Name", value: "projectName" },
  { label: "Project Category", value: "projectCategory" },
  { label: "Entrepreneur", value: "entrepreneur" },
  { label: "Submission Date", value: "submissionDate" },
  { label: "Industry", value: "industry" },
  { label: "Status", value: "status" },
  { label: "Action", value: "action" },
];

export const sectorInterest_table_header = [
  { label: "SNo.", value: "srno" },
  { label: "Name", value: "name" },
  { label: "Date", value: "createdAt" },
  { label: "Action", value: "action" },
];
export const ticketSize_table_header = [
  { label: "SNo.", value: "srno" },
  { label: "Date", value: "createdAt" },
  { label: "Min Range", value: "min" },
  { label: "Max Range", value: "max" },
  { label: "Action", value: "action" },
];

export const projectManagement_filter_data = [
  { label: "All", value: "all" },
  ...Object.values(PROJECT_STATUS).map((status) => ({
    label: PROJECT_STATUS_NAME[status],
    value: status,
  })),
];

export const ambassadors_table_header = [
  { label: "SNo.", value: "srno" },
  { label: "Name", value: "name" },
  { label: "Designation", value: "designation" },
  { label: "Created At", value: "createdAt" },
  { label: "Action", value: "action" },
];

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
